import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import {CurrentUserService} from '../api'

const initialState = {
    user_id: undefined,
    name: undefined,
    email: undefined,
    userName: undefined,
    fullName: undefined,
    is_staff: false,
    creditConsumed: undefined,
    creditLimit: undefined,
    isLimitInfinity: false,
    planType: undefined,
    roleType: undefined,
    editingUserName: '',
    editingPassword: '',
    showPassword: false,
    error: undefined,
    isLoginAgainPopupShow: false,
    account: undefined,
}

const signInUser = createAsyncThunk(
    'signInUser',
    async ({navigate, isLoginAgain}: any, thunkAPI: any) => {
        const {editingUserName, editingPassword} = thunkAPI.getState().currentUser
        if (!editingUserName) {
            thunkAPI.dispatch(currentUserActions.setError("メールアドレスが入力されていません。"))    
            return
        }
        if (!editingPassword) {
            thunkAPI.dispatch(currentUserActions.setError("パスワードが入力されていません。"))    
            return
        }
        const trimEmail = editingUserName.trim()
        const res = await CurrentUserService.currentUserLogin({requestBody:{username: trimEmail, password: editingPassword, is_login_again: isLoginAgain}})
        if (res.success) {
            thunkAPI.dispatch(currentUserActions.setInitState())
            thunkAPI.dispatch(currentUserActions.setUserName(editingUserName))
            navigate("/");
            return
        }

        if (res.message == 'user_logged_in_already') {
            thunkAPI.dispatch(currentUserActions.setIsLoginAgainPopupShow(true))
            return
        }

        thunkAPI.dispatch(currentUserActions.setError(res.message))
    },
)

const signOutUser = createAsyncThunk(
    'signOutUser',
    async (navigate: any, thunkAPI: any) => {
        try {
            await CurrentUserService.currentUserLogout()
        } catch (e) {
            //do nothing
        }
        thunkAPI.dispatch(currentUserActions.setInitState())
        navigate("/login");
        return
    },
)

const getCurrentUser = createAsyncThunk(
    'getCurrentUser',
    async (navigate: any, thunkAPI: any) => {
        const res = await axios.get('/api/get-current-user').catch(() => false) as any
        thunkAPI.dispatch(currentUserActions.setInitState())
        if (!res) {
            navigate("/login");
            return
        }
        const data = res.data
        if (data.id) {
            const {id, email, user_name, full_name, is_staff, account, role_type, credit_consumed, credit_limit} = data
            thunkAPI.dispatch(currentUserActions.setUserId(id))
            thunkAPI.dispatch(currentUserActions.setEmail(email))
            thunkAPI.dispatch(currentUserActions.setUserName(user_name))
            thunkAPI.dispatch(currentUserActions.setFullName(full_name))
            thunkAPI.dispatch(currentUserActions.setIsStaff(is_staff))
            thunkAPI.dispatch(currentUserActions.setCreditConsumed(credit_consumed || 0))
            thunkAPI.dispatch(currentUserActions.setCreditLimit(credit_limit || 0))
            thunkAPI.dispatch(currentUserActions.setLimitInfinity(credit_limit === null))
            thunkAPI.dispatch(currentUserActions.setAccount(account))
            const planType = account && account.plan_type ? account.plan_type.name : undefined
            thunkAPI.dispatch(currentUserActions.setPlanType(planType))
            const roleType = role_type ? role_type.name : undefined
            thunkAPI.dispatch(currentUserActions.setRoleType(roleType))

            const afterState = thunkAPI.getState().currentUser
            console.log('@@ currentUser', {
                user_id: afterState.user_id,
                email: afterState.email,
                userName: afterState.userName,
                fullName: afterState.fullName,
                is_staff: afterState.is_staff,
                creditConsumed: afterState.creditConsumed,
                creditLimit: afterState.creditLimit,
                isLimitInfinity: afterState.isLimitInfinity,
                planType: afterState.planType,
                roleType: afterState.roleType,
                account: afterState.account
            })
            return
        }

        navigate("/login");
    },
)

const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState,
    reducers: {
        setUserId: (state, action) => {
            state.user_id = action.payload
        },
        setEmail: (state, action) => {
            state.email = action.payload
        },
        setUserName: (state, action) => {
            state.userName = action.payload
        },
        setFullName: (state, action) => {
            state.fullName = action.payload
        },
        setIsStaff: (state, action) => {
            state.is_staff = action.payload
        },
        setCreditConsumed: (state, action) => {
            state.creditConsumed = action.payload
        },
        setCreditLimit: (state, action) => {
            state.creditLimit = action.payload
        },
        setLimitInfinity: (state, action) => {
            state.isLimitInfinity = action.payload
        },
        setPlanType: (state, action) => {
            state.planType = action.payload
        },
        setRoleType: (state, action) => {
            state.roleType = action.payload
        },
        setEditingUserName: (state, action) => {
            state.editingUserName = action.payload
        },
        setEditingPassword: (state, action) => {
            state.editingPassword = action.payload
        },
        switchShowPassword: (state) => {
            state.showPassword = !state.showPassword
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setIsLoginAgainPopupShow: (state, action) => {
            state.isLoginAgainPopupShow = action.payload
        },
        setInitState: (state) => {
            return initialState
        },
        setAccount: (state, action) => {
            state.account = action.payload
        },
    },
})

const currentUserActions = {
    ...currentUserSlice.actions,
    signInUser,
    signOutUser,
    getCurrentUser
}
export {currentUserActions}
export default currentUserSlice.reducer